export default __webpack_public_path__ + "static/media/AGC_Question_Paper_Class_3.c7d71785.pdf";